module.exports = cfp.vendors.ReactJsxRuntime;